<template>
  <div class="bottom-navigation">
    <div class="nav-list flex-row">
      <div class="nav-item flex-col justify-between" v-for="(item, index) in navigationItems" :key="index"
        @click="navigateTo(item.route)" :class="{ 'active': isActive(item.route) }">
        <img class="nav-icon" :src="getIconSrc(item)" />
        <span class="nav-text" :style="{ color: getTextColor(item.route) }" v-html="item.text"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomNavigation',
  props: {
    currentRoute: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      navigationItems: [
        {
          icon: require('./assets/img/shouye.png'),
          activeIcon: require('./assets/img/shouye_xuanzhong.png'),
          text: '首页',
          route: '/shouye',
          activeColor: 'rgba(0,203,106,1.000000)',
          inactiveColor: 'rgba(190,190,190,1.000000)'
        },
        {
          icon: require('./assets/img/zhanghaoliebiao.png'),
          activeIcon: require('./assets/img/zhanghaoguanli_xuanzhong.png'),
          text: '账号列表',
          route: '/lanhu_zhanghaoguanli',
          activeColor: 'rgba(0,203,106,1.000000)',
          inactiveColor: 'rgba(190,190,190,1.000000)'
        },
        {
          icon: require('./assets/img/jifenshangchen.png'),
          activeIcon: require('./assets/img/jifenshangcheng_xuanzhong.png'),
          text: '积分商城',
          route: '/lanhu_jifenchongzhi',
          activeColor: 'rgba(0,203,106,1.000000)',
          inactiveColor: 'rgba(190,190,190,1.000000)'
        },
        {
          icon: require('./assets/img/wode.png'),
          activeIcon: require('./assets/img/wode_xuanzhong.png'),
          text: '我的',
          route: '/lanhu_wode',
          activeColor: 'rgba(0,203,106,1.000000)',
          inactiveColor: 'rgba(190,190,190,1.000000)'
        }
      ]
    };
  },
  methods: {
    navigateTo(route) {
      if (route && route !== this.$route.path) {
        this.$router.push(route);
      }
    },
    isActive(route) {
      return this.$route.path === route || this.currentRoute === route;
    },
    getTextColor(route) {
      const item = this.navigationItems.find(nav => nav.route === route);
      if (!item) return 'rgba(190,190,190,1.000000)';

      return this.isActive(route) ? item.activeColor : item.inactiveColor;
    },
    getIconSrc(item) {
      return this.isActive(item.route) ? item.activeIcon : item.icon;
    }
  }
};
</script>

<style scoped>
/* 通用flex布局类 */
.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.justify-between {
  justify-content: space-between;
}

/* 底部导航栏样式 */
.bottom-navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 1);
  border-top: 1px solid rgba(240, 240, 240, 1);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.nav-list {
  width: 100%;
  height: 60px;
  padding: 8px 0;
  justify-content: space-around;
  align-items: center;
}

.nav-item {
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 8px;
  min-width: 60px;
  align-items: center;
}

.nav-item:hover {
  background-color: rgba(0, 203, 106, 0.1);
  transform: translateY(-2px);
}

.nav-item:active {
  transform: translateY(0);
}

.nav-item.active {
  background-color: rgba(0, 203, 106, 0.05);
}

.nav-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
  /* 增加图标清晰度 */
  image-rendering: -webkit-optimize-contrast;
}

.nav-text {
  font-size: 12px;
  font-family: Source Han Sans CN-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 12px;
  transition: color 0.3s ease;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .bottom-navigation {
    width: 100%;
  }
}
</style>